/**
 * 格子状态定义。与 App 端 CellState 语义对齐（见 starbattle-package 的 CellState.cs）。
 *
 * 状态转移由玩法层 InteractionRules 决定，本文件只描述状态本身的元数据：
 *   - countsAsStar：是否算作一颗星（参与行/列/区计数与相邻判定）
 *   - removable：玩家能否再次操作把它移除（星与红叉一旦落下即锁定）
 */

export const EMPTY = 0;
/** 正确落星（双击命中唯一解）。锁定。 */
export const STAR = 1;
/** 玩家手动标记的排除位。可反复切换。 */
export const WHITE_CROSS = 2;
/** 错误落星（双击未命中唯一解）→ 扣一条命。锁定。 */
export const RED_CROSS = 3;

/** @type {Record<number, { countsAsStar: boolean, removable: boolean, key: string }>} */
export const CELL_META = {
    [EMPTY]: { countsAsStar: false, removable: true, key: 'empty' },
    [STAR]: { countsAsStar: true, removable: false, key: 'star' },
    [WHITE_CROSS]: { countsAsStar: false, removable: true, key: 'whiteCross' },
    [RED_CROSS]: { countsAsStar: false, removable: false, key: 'redCross' },
};

/** @param {number} state */
export function countsAsStar(state) {
    return CELL_META[state].countsAsStar;
}

/** @param {number} state */
export function isRemovable(state) {
    return CELL_META[state].removable;
}

/** @param {number} state */
export function stateKey(state) {
    return CELL_META[state].key;
}
